import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { Filter, Main } from 'Containers';
import { LoadingPage, TitledCard } from 'Components/';
import {
  createToast,
  toastType,
  errorToast,
  toastError,
} from 'Common/ToastHelper';
import { UPDATE_CEP_COUNTS_FORM_NAME } from 'Common/FormEnum';
import { UpdateCEPCountsFieldEnum as Fields } from 'Common/FieldEnum';
import {
  fetchSites,
  clearErrors,
  updateCEPCounts,
  clearSuccess,
} from './state/update/actions';
import { UpdateCEPCountsForm } from './components/UpdateCEPCountsForm';
import SelectSitesTable from 'Common/SelectSitesTable';
import { getLoading, getSites, getErrors, getSuccess } from './state/selectors';

class UpdateCEPCountsContainer extends Component {
  state = {
    selectedSites: [],
  };

  handleSubmit = formValues => {
    const { selectedSites } = this.state;
    if (!selectedSites.length) {
      return toastError('A site must be selected.');
    }
    const values = { ...formValues, selectedSites };
    this.props.updateCEPCounts(values);
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: UPDATE_CEP_COUNTS_FORM_NAME,
        saveButtonProps: {
          content: 'Update',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.fetchSites();
  }

  componentDidUpdate(prevProps, prevState) {
    const { success, clearSuccess } = this.props;
    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearErrors();
    }
    if (success) {
      createToast(toastType.success, 'Success', 'Update CEP counts complete.');
      clearSuccess();
    }
  }

  handleSiteChange = values => {
    this.setState({
      selectedSites: values,
    });
  };

  render() {
    const { loading, sites } = this.props;
    return (
      <Fragment>
        {loading ? <LoadingPage /> : undefined}
        <Filter title={'Update CEP Counts'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <UpdateCEPCountsForm
              onSubmit={this.handleSubmit}
              loading={loading}
              initialValues={{
                [Fields.FromDate]: moment().format('MM/YYYY'),
              }}
              sites={sites}
            />
            <SelectSitesTable
              fetchSites={false}
              sites={sites}
              onChange={this.handleSiteChange}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: getLoading(state),
    sites: getSites(state),
    error: getErrors(state),
    success: getSuccess(state),
  };
};

export const UpdateCEPCounts = withRouter(
  connect(
    mapStateToProps,
    {
      fetchSites,
      clearErrors,
      updateCEPCounts,
      clearSuccess,
    }
  )(UpdateCEPCountsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/UpdateCEPCounts.js